const NON_BLOCKING_MUTATION_KEYS = new Set([
  "quickUpdateExperiment",
  "quickUpdateVariant",
  "quickCreateChange",
  "quickUpdateChange",
  "quickStartExperiment",
  "quickEndExperiment",
  "inlineVariantSave",
]);

type MutationLoaderOptions = {
  mutationKey?: readonly unknown[];
  meta?: Record<string, unknown>;
};

export const shouldShowGlobalMutationLoader = ({
  mutationKey = [],
  meta,
}: MutationLoaderOptions): boolean => {
  if (meta?.suppressGlobalLoader === true) return false;
  return !mutationKey.some(
    (key) => typeof key === "string" && NON_BLOCKING_MUTATION_KEYS.has(key),
  );
};
